import { createContext } from 'react';

const YoutrackContext = createContext({ services: [] });

export default YoutrackContext;
